import {
  Divider as MuiDivider,
  type DividerProps as MuiDividerProps,
} from '@mui/material';

interface DividerProps extends MuiDividerProps {
  sx?: any;
}

export const Divider = (props: DividerProps) => (
  <MuiDivider sx={{ ...props.sx }} {...props} />
);
